import useSWR from "swr";
import axios from "../api/axios";

export interface AdminContentOption {
  id: string;
  title: string;
}

async function fetchContents(creatorId?: string): Promise<AdminContentOption[]> {
  try {
    const params: Record<string, string | number> = { page: 1, pageSize: 200 };
    if (creatorId) {
      params.createdByUserId = creatorId;
    }
    const res = await axios.get("/content", { params });
    const list: AdminContentOption[] = Array.isArray(res.data)
      ? res.data
          .map((content: any) => ({
            id: content.id ?? content.Id ?? "",
            title: content.title ?? content.Title ?? "Untitled",
          }))
          .filter((item: AdminContentOption) => Boolean(item.id))
      : [];
    return list;
  } catch (error) {
    console.error("[admin] load contents failed", error);
    return [];
  }
}

export default function useAdminContentOptions(enabled: boolean, creatorId?: string) {
  type Key = readonly ["admin-content-options", string];
  return useSWR<AdminContentOption[], any, Key | null>(enabled ? (["admin-content-options", creatorId ?? ""] as Key) : null,
    ([, scopeId]) => fetchContents(scopeId || undefined),
    {
      revalidateOnFocus: false,
    },
  );
}
